/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, {memo} from 'react';

import find from 'lodash/find';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import { LinkContainer } from 'react-router-bootstrap';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { APP_COLORS } from '../Constants';
import { clearState, logout } from "../account/accountSlice";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getVersion } from '../Utils';
import { useDispatch, useSelector } from "react-redux";

import logoIcon from '../assets/img/ToolBelt_Icon.png'

const Menu = memo(function Menu(props) {
    const { menu } = props;
    const { account } = useSelector(state => state.account);

    const dispatch = useDispatch();

    const handleSignOut = () => {
        dispatch(clearState());
        dispatch(logout());
    };

    const givenName = account?.givenName || '';
    const surName = account?.surName || '';
    const email = account?.email || '';

    const homeMenuItem = find(menu, {name: 'HOME'});
    const homePath = homeMenuItem?.path || '/';

    return (
        <Row g={0}>
            <Col>
                <Navbar className="navbar-bordered" expand="lg">
                    <LinkContainer to={homePath}>
                        <Navbar.Brand>
                            <img
                                src={logoIcon}
                                width="30"
                                height="30"
                                className="d-inline-block align-top"
                                alt="ToolBeltData Logo"
                            />
                        </Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {<MenuItems menu={menu}/>}
                        </Nav>
                        <Nav className="ms-auto user-nav">
                            <NavDropdown title={<FontAwesomeIcon icon={faUser} />} id="basic-nav-dropdown" align="end">
                                <NavDropdown.Item disabled style={{textAlign: 'center'}}><FontAwesomeIcon color={APP_COLORS.info} icon={faUser} /></NavDropdown.Item>
                                <NavDropdown.Item disabled style={{textAlign: 'center', fontSize: '1rem'}}>{`${givenName} ${surName}`}</NavDropdown.Item>
                                <NavDropdown.Item disabled style={{textAlign: 'center', fontSize: '.9rem'}}>{email}</NavDropdown.Item>
                                <NavDropdown.Item
                                    disabled
                                    style={{fontSize: '.75rem', textAlign: 'center'}}
                                >
                                    {getVersion(false)}
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item
                                    onClick={() => handleSignOut()}
                                    style={{fontSize: '.9rem', textAlign: 'center'}}
                                >
                                    Sign Out
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Col>
        </Row>
    )
});

export default Menu;

const MenuItems = memo(props => {
    if (props.menu && Array.isArray(props.menu)) {
        return props.menu.map((m, i) => {
            // SubMenu
            if (m.subMenu && m.subMenu.length > 0) {
                const navDropDownItems = m.subMenu.map(sm => {
                    if (sm.path) {
                        return (
                            <LinkContainer key={`${i}-${sm.path}`} to={`${sm.path}`}>
                                {sm.divider ? (
                                    <NavDropdown.Divider />
                                ) : (
                                    <NavDropdown.Item>{sm.name}</NavDropdown.Item>
                                )}
                            </LinkContainer>
                        )
                    } else {
                        return (
                            <NavDropdown.Item key={`${i}-${sm.name}`}>{sm.name}</NavDropdown.Item>
                        )
                    }
                })
                return (
                    <NavDropdown key={i} title={m.name} id={`menu-${m.name.toLowerCase()}-nav-dropdown`} className="font-weight-bold">
                        {navDropDownItems}
                    </NavDropdown>
                )
            }
            // Mega Menu
            if (m.megaMenu) {
                const getNavDropDownItems = (c) => {
                    if (c.path) {
                        return (
                            <LinkContainer key={`${i}-${c.path}`} to={`${c.path}`}>
                                {c.divider ? (
                                    <NavDropdown.Divider />
                                ) : (
                                    <NavDropdown.Item id={`${i}-${c.name}`}>{c.name}</NavDropdown.Item>
                                )}
                            </LinkContainer>
                        )
                    } else {
                        return (
                            <NavDropdown.Item id={`${i}-${c.name}`} key={`${i}-${c.name}`}>{c.name}</NavDropdown.Item>
                        )
                    }
                }

                // TODO This could be made much more interesting
                const administerDropDownItems = m.megaMenu.administer.map(c => getNavDropDownItems(c));
                const entitiesDropDownItems = m.megaMenu.entities.map(c => getNavDropDownItems(c));
                const configureDropDownItems = m.megaMenu.configure.map(c => getNavDropDownItems(c));
                const toolsDropDownItems = m.megaMenu.tools.map(c => getNavDropDownItems(c));
                return (
                    <NavDropdown key={i} title={m.name} id={`menu-${m.name.toLowerCase()}-nav-dropdown`} className="font-weight-bold">
                        <Row style={{minWidth: '400px'}}>
                            <Col xl={6} lg={6} md={6} sm={6} style={{minWidth: '200px'}}>
                                <NavDropdown.Item style={{fontWeight: 'bold', color: APP_COLORS["gray-600"]}}>Administer</NavDropdown.Item>
                                {administerDropDownItems}
                                <NavDropdown.Item style={{fontWeight: 'bold', color: APP_COLORS["gray-600"]}}>Configure</NavDropdown.Item>
                                {configureDropDownItems}
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6} style={{minWidth: '200px'}}>
                                <NavDropdown.Item style={{fontWeight: 'bold', color: APP_COLORS["gray-600"]}}>Entities</NavDropdown.Item>
                                {entitiesDropDownItems}
                                <NavDropdown.Item style={{fontWeight: 'bold', color: APP_COLORS["gray-600"]}}>Tools</NavDropdown.Item>
                                {toolsDropDownItems}
                            </Col>
                        </Row>
                    </NavDropdown>
                )
            }
            return (
                <LinkContainer key={i} to={`${m.path}`}>
                    <Nav.Link className="font-weight-bold">{m.name}</Nav.Link>
                </LinkContainer>
            )
        })
    } else {
        return null;
    }
});
